import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DelegateSimpleModel} from '../../team/models/delegate.model';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-manager-panel',
  templateUrl: './manager-panel.component.html',
  styleUrls: ['./manager-panel.component.scss'],
})
export class ManagerPanelComponent implements OnInit {
    @Input() managerId = 0;
    @Input() managers: DelegateSimpleModel[] = null;
    @Output() managerChange = new EventEmitter<number>();

    constructor(public userService: UserService,) {
    }

    selectFilter(manager_id) {
        this.managerId = manager_id;
        this.managerChange.emit(manager_id);
    }

    ngOnInit() {
    }
}
